module.exports = __webpack_public_path__ + "img/icon_share_3.bf856a96.png";